import React from 'react';
import {
    ARTICLES,
    PRODUCTS
} from '../../constants/index.js';
import {
    addResourceStrings,
    translateResourceString
} from '../../../util/translationUtility';

import { ArticleSearch, ProductSearch } from '../../SearchApp';

import { NavItem, NavLink, TabContent, TabPane, Card, CardHeader, CardBody } from 'reactstrap';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            view: props.View && props.View === ARTICLES
                ? ARTICLES
                : PRODUCTS
        };

        this.onChangeView = this.onChangeView.bind(this);
        addResourceStrings(props.LocalizationItems);
    }

    onChangeView(view) {
        this.setState({ view: view });
    }

    render() {
        const { Articles, Products, SearchString, OriginalSearchString, Suggestions, FindClickTracking, WishlistData } = this.props;
        const showNoResultsFound = Articles.Pagination.ResultsTotal + Products.Pagination.ResultsTotal === 0;
        const showArticles = this.state.view === ARTICLES;
        const showProducts = !showArticles;

        return (
            <div className="combined-search-wrapper">
                {showNoResultsFound ?
                    <div>
                        <div className="row pb-5">
                            <div className="col-12">
                                <div className="page__title">
                                    <p>
                                        {translateResourceString("/Search/YourSearchOf")} "{SearchString}" {translateResourceString("/Search/DidNotMatch")}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {Suggestions && Suggestions.length > 0 &&
                            <div className="pb-5">
                                <div className="row">
                                    <div className="col-12">
                                        <div id="did-you-mean">
                                            <p>
                                                {translateResourceString("/Search/DidYouMean")} {Suggestions.map((suggestion, i) => {
                                                    return (
                                                        <span key={`suggestion-${i}`}>
                                                            <a href={suggestion.Url}>{suggestion.Text}</a>
                                                            {i + 1 < Suggestions.length ? ", " : ""}
                                                        </span>
                                                    )
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col-12">
                                <p className="search-suggestions-heading">
                                    <strong>{translateResourceString("/Search/TrySomethingLike")}:</strong>
                                </p>
                                <ul className="search-suggestions">
                                    <li>{translateResourceString("/Search/UsingMoreGeneral")}</li>
                                    <li>{translateResourceString("/Search/CheckingYourSpelling")}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    : 
                    <div>
                        <div className="search-page__title-wrapper">
                            {!OriginalSearchString
                                ? <h1 className="search-page__title">{translateResourceString("/Search/ResultHeader")} {SearchString && <span>{translateResourceString("/Search/ResultFor")} "{SearchString}"</span>}</h1>
                                :<>
                                    <h1 className="search-page__title">{translateResourceString("/Search/AutocorrectShowingResultsFor")} <span>"{SearchString}"</span></h1>
                                    <p className="search-page__title__no-results">{translateResourceString("/Search/AutocorrectNoResultsFoundFor")} <span>"{OriginalSearchString}"</span></p>
                                </> 
                            }
                        </div>
                        
                        <Card className="combined-search__card">
                            <CardHeader className="combined-search__card-header">
                                <div className="nav nav-tabs card-header-tabs">
                                    <NavItem>
                                        <NavLink
                                            className={showProducts ? "active" : ""}
                                            onClick={() => this.onChangeView(PRODUCTS)}
                                            href="#"
                                            role="button"
                                        >
                                            {translateResourceString("/Search/ProductsTab")}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={showArticles ? "active" : ""}
                                            onClick={() => this.onChangeView(ARTICLES)}
                                            href="#"
                                            role="button"
                                        >
                                            {translateResourceString("/Search/ArticlesTab")}
                                        </NavLink>
                                    </NavItem>
                                </div>
                            </CardHeader>
                            <CardBody className="combined-search__card-body">
                                <TabContent activeTab={this.state.view}>
                                    <TabPane tabId={PRODUCTS}>
                                        <ProductSearch {...Products} FindClickTracking={FindClickTracking} WishlistData={WishlistData} OriginalSearchString={OriginalSearchString} />
                                    </TabPane>
                                    <TabPane tabId={ARTICLES}>
                                        <ArticleSearch {...Articles} FindClickTracking={FindClickTracking} OriginalSearchString={OriginalSearchString} />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </div>
                }
            </div>
        )
    }
}